import { useEffect, useState } from "react";
import LeftNav from "../../component/leftNav";
import Layout from "../../layout/Layout";
import GatheringModalWrap from "../../component/GatheringModalWrap";
import { useDispatch, useSelector } from "react-redux";
import { setModalState, setStep } from "../../redux/communityStepSlice";
import * as APIS from "../../utils/service";

const Community = ({ children }) => {
    const dispatch = useDispatch();
    const [mobileCommunity, setMobileCommunity] = useState(false);

    const { step, modalState } = useSelector((s) => s.communityStepReducer);

    const [favList, setFavList] = useState([])
    // const handleStepChange = (newStep) => {
    //     dispatch(setStep(newStep));
    // };
    // const handleModalState = (state) => {
    //     dispatch(setModalState(state));
    // };

    useEffect(() => {
        if (modalState) {
            document.body.style.overflow = "hidden";
        } else {
            loadFav();
            document.body.style.overflow = "auto";
        }

        // Cleanup function to reset overflow when component unmounts
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [modalState]);

    const resetModalState = () => {
        dispatch(setStep(1))
        dispatch(setModalState(false))
    }

    const loadFav = () => {
        APIS.postData('/v1/communityGroup/myFav', {})
            .then(({ data }) => {
                setFavList(data)
            }).catch(({ response }) => {
                setFavList([])
            })
    }

    useEffect(() => {
        loadFav();
        resetModalState();
    }, [])
    return (
        <>
            {/* <div className={`overlay_community ${modalState ? "active" : ""}`}> */}
            {modalState && <div className={`overlay_community active`}>
                <GatheringModalWrap
                    step={step}
                    setStep={setStep}
                    modalState={modalState}
                    setModalState={setModalState}
                />
            </div>}
            <Layout
                header={false}
                actives={"6"}
                footters={true}
            // setsell_type={setsell_type}
            // setcategory_1={setcategory_1}
            // setcategory_2={setcategory_2}
            >
                <div className=" community_wrap">
                    {/* 커뮤니티 왼쪽  */}
                    <div
                        className={`mobile_comnuity_info ${mobileCommunity ? "active" : ""
                            }`}
                    >
                        <LeftNav
                            setStep={setStep}
                            modalState={modalState}
                            setModalState={setModalState}
                        />
                    </div>
                    <div className="comnuity_info_nav">
                        <LeftNav
                            setStep={setStep}
                            modalState={modalState}
                            setModalState={setModalState}
                            favList={favList}
                        />
                    </div>

                    {/* 커뮤니티 오른쪽  */}
                    <div
                        style={{
                            width: "100%",
                            maxWidth: "900px",
                            position: "relative",
                        }}
                    >
                        <div
                            className="community_clk"
                            onClick={() => setMobileCommunity(!mobileCommunity)}
                        >
                            <div className="community_clk_img">
                                <img
                                    src={`./images/icons/list_chk_purple.svg`}
                                />
                            </div>
                        </div>
                        {/* <Outlet /> */}
                        {children}
                    </div>
                </div>
            </Layout>
        </>
    );
};
export default Community;
